export default __webpack_public_path__ + "static/media/NIAS0410.34I106400_-16864_0.757893b4.jpg";